import { render } from "./ThxCardsView.vue?vue&type=template&id=565671be&scoped=true"
import script from "./ThxCardsView.vue?vue&type=script&lang=js"
export * from "./ThxCardsView.vue?vue&type=script&lang=js"

import "./ThxCardsView.vue?vue&type=style&index=0&id=565671be&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kobayashi.y\\develop\\thxily_fastapi\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565671be"]])

export default __exports__